module.exports = __webpack_public_path__ + "img/VP-Lite_Overview-Front_1.371e3902.jpg";